const en_pages = {
  // ── About ──────────────────────────────────────────────────────
  "about.hero.badge": "About Us",
  "about.hero.heading": "Precision Medicine Platform",
  "about.hero.words": "Precision Medicine Platform|Real Clinical Depth|Care Without Borders|We Understand Before We Decide",
  "about.hero.desc": "The Medical Avenue is not a traditional clinic — it is a precision medicine platform combining clinical depth, advanced technologies, and international reach",
  "about.mission.badge": "Our Mission",
  "about.mission.heading": "We Understand Before We Decide",
  "about.mission.desc": "We believe every patient deserves a real assessment that understands their unique biology — not a generic protocol applied to everyone",
  "about.mission.vision_badge": "Our Mission & Vision",
  "about.mission.vision_title": "What Drives Us Every Day",
  "about.values.badge": "Our Values",
  "about.values.heading": "The principles that guide every decision",
  "about.team.badge": "Our Team",
  "about.team.heading": "Elite Consultants",
  "about.team.desc": "Every consultant at The Medical Avenue combines deep clinical expertise with specialized international training",
  "about.cta.heading": "Start Your Journey With Us",
  "about.cta.desc": "A deep assessment session that builds a clear picture of your health trajectory",
  "about.cta.ready_heading": "Are you ready for real understanding?",
  "about.cta.ready_desc": "Book an assessment session today and discover the difference precision medicine makes for your case",
  "about.story.founded_year_label": "Founded Year",
  "about.story.specialist_label": "Specialized Consultants",
  "about.dimensions.heading": "Three Integrated Dimensions",
  "about.dimensions.badge": "Positioning & Distinction",
  "about.dimensions.subtitle": "Our competitive strength lies not in appearance, but in the integrated structure of care — clinical depth, technical depth, and international depth",
  "about.dimensions.clinical.title": "Clinical Depth",
  "about.dimensions.clinical.item1": "90–120 minute sessions",
  "about.dimensions.clinical.item2": "Non-rushed assessment",
  "about.dimensions.clinical.item3": "Multidisciplinary understanding",
  "about.dimensions.clinical.item4": "Reading beyond the symptom",
  "about.dimensions.technical.title": "Technical Depth",
  "about.dimensions.technical.item1": "DNA Risk Score",
  "about.dimensions.technical.item2": "Biological Age",
  "about.dimensions.technical.item3": "Functional Metabolic Assessment",
  "about.dimensions.technical.item4": "Future Risks",
  "about.dimensions.international.title": "International Depth",
  "about.dimensions.international.item1": "Organized Second Opinion",
  "about.dimensions.international.item2": "Centers in USA & South Korea",
  "about.dimensions.international.item3": "International expertise network",
  "about.dimensions.international.item4": "Cross-border follow-up",
  "about.timeline.badge": "Our Journey",
  "about.timeline.title": "The journey of building the precision medicine platform",
  "about.awards.badge": "Our Achievements",
  "about.awards.title": "Accreditations & Partnerships",
  "about.team.view_all": "View All Consultants",
  "about.team.experience": "experience",

  // ── Services ───────────────────────────────────────────────────
  "services.hero.badge": "Our Services",
  "services.hero.heading": "Precision Medicine Services",
  "services.hero.words": "Precision Medicine Services|Unmatched Clinical Depth|Care Built on Your Biology|We Anticipate Before We Chase",
  "services.hero.desc": "Specialized services combining clinical depth and advanced technologies to build a comprehensive picture of your health trajectory",
  "services.filter.all": "All",
  "services.search.placeholder": "Search for a service...",
  "services.sort.default": "Default",
  "services.sort.price_asc": "Price: Low to High",
  "services.sort.price_desc": "Price: High to Low",
  "services.no_results": "No matching services found",
  "services.from": "From",
  "services.book": "Book Now",
  "services.details": "Details",
  "services.cta.heading": "Need Help Choosing?",
  "services.cta.desc": "Our team is ready to help you choose the right service for your case",
  "services.stats.specialized": "Specialized Services",
  "services.stats.duration": "min per session",
  "services.stats.partners": "International Partners",
  "services.stats.rating": "Patient Rating",
  "services.label.doctors": "Doctors",
  "services.label.procedures": "Procedures",
  "services.why.heading": "Why Are Our Services Different?",
  "services.why.desc": "We combine clinical depth, technical precision, and international reach",
  "services.why.item1.title": "90–120 Min Sessions",
  "services.why.item1.desc": "We give each case the time it deserves — some files can't be understood in minutes",
  "services.why.item2.title": "Precision Medicine Tech",
  "services.why.item2.desc": "DNA Risk Score, Biological Age, Functional Metabolic Assessment",
  "services.why.item3.title": "Real International Reach",
  "services.why.item3.desc": "Second Opinion from centers in USA & Korea for complex cases",
  "services.why.item4.title": "Personal Plan for Each Case",
  "services.why.item4.desc": "No generic protocols — every patient has a unique biology and health trajectory",
  "services.cta.browse_packages": "Browse Packages",

  // ── Packages ───────────────────────────────────────────────────
  "packages.hero.badge": "Care Levels",
  "packages.hero.heading": "Choose the Right Assessment Level for Your Case",
  "packages.hero.words": "Choose the Right Assessment Level|Packages Designed for Your Biology|Integrated Care from Assessment to Follow-up|A Personal Plan, Not a Generic Protocol",
  "packages.hero.desc": "From comprehensive deep assessment to integrated international care — each level is designed for a different case, and every plan is built on your unique biology",
  "packages.filter.all": "All",
  "packages.filter.label": "Filter Packages",
  "packages.sort.label": "Sort By",
  "packages.price_range": "Price Range",
  "packages.category": "Category",
  "packages.reset": "Reset Filters",
  "packages.available": "package available",
  "packages.single_count": "package",
  "packages.plural_count": "packages",
  "packages.all_summary": "{{count}} packages across {{catCount}} care levels",
  "packages.cat_summary": "{{count}} packages available",
  "packages.note": "All packages include VAT. Every plan is built on actual case assessment — no generic protocols.",
  "packages.cta.heading": "Need Help Choosing?",
  "packages.cta.desc": "Our precision medicine experts are ready to help you choose the right level for your case",
  "packages.cta.book": "Book an Assessment Session",
  "packages.cta.contact": "Contact Us",
  "packages.save": "Save",
  "packages.features_more": "more features",
  "packages.features_label": "{{count}} more features",
  "packages.category.deep_assessment": "Deep Assessment",
  "packages.category.deep_assessment.desc": "Comprehensive assessment sessions that reveal what lies beyond symptoms and build an integrated health picture",
  "packages.category.precision_medicine": "Precision Medicine",
  "packages.category.precision_medicine.desc": "An integrated platform that combines deep assessment and DNA analysis to build a personalized preventive plan",
  "packages.category.metabolic_dysfunction": "Metabolic Dysfunction",
  "packages.category.metabolic_dysfunction.desc": "Specialized assessment for obesity, fatty liver disease, and chronic metabolic dysfunction",
  "packages.category.second_opinion": "Second Opinion",
  "packages.category.second_opinion.desc": "International medical opinion from specialized centers in the USA, Korea, and Germany",
  "packages.category.genetics_dna": "Genetics & DNA",
  "packages.category.genetics_dna.desc": "Comprehensive genetic analysis revealing future health risks before they appear",
  "packages.category.psychiatry": "Psychiatry",
  "packages.category.psychiatry.desc": "Deep psychiatric assessment integrating genetic and cognitive aspects for comprehensive care",
  "packages.category.osteoporosis": "Osteoporosis",
  "packages.category.osteoporosis.desc": "Specialized assessment of bone density and genetic risks with an intensive treatment plan",
  "packages.category.iv_therapy": "IV Therapy",
  "packages.category.iv_therapy.desc": "Customized IV protocols to support cellular energy, metabolism, and the nervous system",
  "packages.category.neuro_prevention": "Neuro-Prevention",
  "packages.category.neuro_prevention.desc": "Specialized prevention programs for Alzheimer's and early cognitive decline",
  "packages.category.international_care": "International Care",
  "packages.category.international_care.desc": "Integrated care combining local depth and international expertise in one system",
  "packages.category.vip": "VIP",
  "packages.category.vip.desc": "Exceptional medical experience with the highest levels of privacy and personalized care",

  // ── Doctors ────────────────────────────────────────────────────
  "doctors.cta.join_heading":"Why Choose Us?",
  "home.why.clinical_depth":"Why Choose Us?",
  "doctors.hero.badge": "Consultants",
  "doctors.hero.heading": "The Medical Avenue Consultants",
  "doctors.hero.words": "The Medical Avenue Consultants|Precision Medicine Experts|Elite Specialists|High Clinical Competence",
  "doctors.hero.desc": "An elite group of specialized consultants combining deep clinical expertise with specialized international training",
  "doctors.filter.all": "All",
  "doctors.search.placeholder": "Search by name or specialty...",
  "doctors.no_results": "No matching doctors found",
  "doctors.book": "Book Consultation",
  "doctors.profile": "View Profile",
  "doctors.fee": "Consultation Fee",
  "doctors.experience": "Years of Experience",
  "doctors.available": "Available for Booking",
  "doctors.specialty.precision": "Precision Medicine & Risk Assessment",
  "doctors.specialty.metabolic": "Metabolic Dysfunction & MASLD",
  "doctors.specialty.psychiatry": "Adult Psychiatry",
  "doctors.specialty.genetics": "Genetics & Precision Medicine",
  "doctors.specialty.osteoporosis": "Intensive Osteoporosis",
  "doctors.specialty.iv": "Specialized IV Therapy",

  // ── Contact ────────────────────────────────────────────────────
  "contact.hero.badge": "Contact Us",
  "contact.hero.heading": "We Are Here to Help",
  "contact.hero.words": "We Are Here to Help|Your Specialized Medical Team|We Respond in Under an Hour|Reach Out with Confidence",
  "contact.hero.desc": "Our team is ready to answer your inquiries and help you choose the right service",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email Address",
  "contact.form.phone": "Phone Number",
  "contact.form.subject": "Subject",
  "contact.form.message": "Your Message",
  "contact.form.submit": "Send Message",
  "contact.form.success": "Your message has been sent successfully!",
  "contact.info.address": "Address",
  "contact.info.phone": "Phone",
  "contact.info.email": "Email",
  "contact.info.hours": "Working Hours",
  "contact.form.send_message": "Send a Message",
  "contact.form.send_another": "Send Another Message",
  "contact.form.select_subject": "Select subject...",
  "contact.form.max_chars": "Max {{count}} characters",
  "contact.form.error_msg": "An error occurred. Please try again.",
  "contact.form.sending": "Sending...",
  "contact.info.working_days": "Saturday - Thursday",
  "contact.info.friday": "Friday",
  "contact.info.follow_us": "Follow Us",
  "contact.dna.title": "Precision Medicine & DNA",
  "contact.dna.description": "For inquiries about DNA Risk Score analysis, biological age assessment, or international second opinion, please mention it in your message subject.",

  // ── Blog ───────────────────────────────────────────────────────
  "blog.hero.badge": "Precision Medicine Blog",
  "blog.hero.heading": "Deeper Knowledge, Sharper Decisions",
  "blog.hero.words": "Deeper Knowledge, Sharper Decisions|Science that Serves Your Health Decision|Content from Real Experts|We Write to Understand, Not to Impress",
  "blog.hero.desc": "Specialized scientific content from The Medical Avenue consultants — in precision medicine, DNA analysis, metabolic dysfunction, and advanced specialty care",
  "blog.filter.all": "All",
  "blog.search.placeholder": "Search precision medicine articles...",
  "blog.read_more": "Read More",
  "blog.min_read": "min read",
  "blog.no_results": "No matching articles found",
  "blog.related": "Related Articles",
  "blog.stats.articles": "Specialized Articles",
  "blog.stats.authors": "Consultant Authors",
  "blog.stats.reads": "Monthly Reads",
  "blog.featured_articles": "Featured Articles",
  "blog.exclusive": "Exclusive Content",
  "blog.featured_badge": "Featured",
  "blog.read": "read",
  "blog.search_results_for": "Search results for:",
  "blog.article_count": "articles",
  "blog.all_articles": "All Articles",
  "blog.try_different_search": "Try different search keywords or another category",
  "blog.philosophy_badge": "Content Philosophy",
  "blog.philosophy_heading": "We write to understand, not to impress",
  "blog.philosophy_desc": "Every article in our blog serves one goal: helping you understand your health condition more deeply",
  "blog.pillar1_title": "Clinical Depth",
  "blog.pillar1_desc": "Articles that dissect the condition and link current health with future risks — not just general advice",
  "blog.pillar2_title": "Technical Depth",
  "blog.pillar2_desc": "Content explaining precision medicine techniques like DNA Risk Score and biological age in clear, scientific language",
  "blog.pillar3_title": "International Depth",
  "blog.pillar3_desc": "Insights derived from our network of expertise in the USA, South Korea, and the world's leading precision medicine centers",
  "blog.newsletter_heading": "Subscribe to Precision Medicine Newsletter",
  "blog.newsletter_desc": "Get the latest precision medicine articles, DNA analysis, and health risk management — straight to your email inbox",
  "blog.newsletter_email_placeholder": "Your email address",
  "blog.newsletter_submit": "Subscribe Now",
  "blog.newsletter_note": "No spam — unsubscribe at any time",
  "blog.detail.personal_evaluation_prompt": "Want a personal assessment?",
  "blog.detail.personal_evaluation_desc": "What you read here is a scientific introduction. A real assessment begins with a deep session with one of our consultants — we understand your specific case before suggesting any plan.",
  "blog.detail.share_article": "Share this article:",
  "blog.detail.copy_link": "Copy Link",
  "blog.detail.view_full_profile": "View Full Profile",
  "blog.detail.author_bio": "A specialized consultant at The Medical Avenue — precision medicine and advanced specialty care platform. Believes that deep understanding of the condition is the foundation of any correct medical decision.",
  "blog.detail.sidebar_book_desc": "Speak with one of our consultants about what you read — deep assessment starts here",
  "blog.detail.view_care_levels": "Browse Care Levels",
  "blog.detail.dimensions_title": "Precision Medicine Dimensions",
  "blog.detail.clinical_depth_sub": "90–120 minute sessions",
  "blog.detail.technical_depth_sub": "DNA, biological age, risks",
  "blog.detail.international_depth_sub": "USA & South Korea",
  "blog.detail.view_all_articles": "View All Articles",
  "blog.detail.related_services": "Related Services",
  "blog.detail.related_service_1": "Health Risk Assessment",
  "blog.detail.related_service_2": "DNA Risk Score",
  "blog.detail.related_service_3": "International Second Opinion",
  "blog.detail.related_service_4": "Care Levels",
  "blog.detail.other_articles": "Other Articles",
  "blog.detail.view_all": "View All",
  "blog.views": "views",

  // ── FAQ ────────────────────────────────────────────────────────
  "faq.hero.badge": "FAQ",
  "faq.hero.heading": "How Can We Help You?",
  "faq.hero.words": "How Can We Help You?|Clear Answers|No Question Left Unanswered|We Clarify Before You Ask",
  "faq.hero.desc": "Clear answers to the most common questions about our services and how we work",
  "faq.search.placeholder": "Search questions...",
  "faq.no_results": "No matching questions found",
  "faq.still_have": "Still have questions?",
  "faq.contact_us": "Contact Our Team",

  // ── DNA Simulator ──────────────────────────────────────────────
  "dna.hero.badge": "Free Interactive Tool",
  "dna.hero.heading": "DNA Risk Score",
  "dna.hero.subheading": "Discover Your Future Health Risk Level",
  "dna.hero.desc": "10 interactive questions analyzing your genetic and environmental risk factors — recommending the most suitable package for your health journey",
  "dna.hero.btn_start": "Start Assessment Now — Free",
  "dna.hero.btn_service": "Learn About the Real DNA Risk Score",
  "dna.stats.questions": "questions only",
  "dna.stats.categories": "health categories",
  "dna.stats.free": "Free",
  "dna.how.badge": "How It Works",
  "dna.how.heading": "How Does the Assessment Work?",
  "dna.how.desc": "We analyze your key risk factors and build an estimated picture of your future health risk level",
  "dna.how.step1_title": "Answer 10 Questions",
  "dna.how.step1_desc": "Questions covering family history, lifestyle, current symptoms, and environmental factors",
  "dna.how.step2_title": "We Analyze Your Risks",
  "dna.how.step2_desc": "An analysis algorithm evaluates 5 key health areas and calculates your overall risk level",
  "dna.how.step3_title": "Personal Recommendation",
  "dna.how.step3_desc": "We recommend the most suitable package for your risk level with a direct booking link",
  "dna.categories.heading": "Health Areas We Assess",
  "dna.btn.start": "Start DNA Risk Score Assessment",
  "dna.btn.free_note": "Completely free · No registration required · Instant results",
  "dna.result.heading": "DNA Risk Score Assessment Results",
  "dna.result.desc": "Based on your answers, here is our estimated assessment of your health risk level",
  "dna.result.analyzed": "Your answers have been analyzed",
  "dna.result.overall": "Overall Risk Level",
  "dna.result.breakdown": "Risk Breakdown by Category",
  "dna.result.detail": "Detailed Risk Analysis",
  "dna.result.recommended": "Recommended Package for Your Case",
  "dna.result.recommended_desc": "Based on your answers, these are the most suitable packages for your risk level",
  "dna.result.best_fit": "Best Fit for Your Case",
  "dna.result.disclaimer": "This assessment is estimated and based on your answers — it does not replace actual clinical assessment with a specialized consultant.",
  "dna.result.book_real": "Book a Real Assessment with a Consultant",
  "dna.result.retake": "Retake Assessment",
  "dna.cta.heading": "Want a Real Genetic Assessment?",
  "dna.cta.desc": "A real DNA Risk Score requires precise laboratory genetic analysis — book a session with our consultants to start your journey",
  "dna.cta.btn_book": "Book a DNA Risk Score Session",
  "dna.cta.btn_service": "Learn About the Service",

  // ── Offers ─────────────────────────────────────────────────────
  "offers.hero.badge": "Current Offers",
  "offers.hero.heading": "Exclusive Limited-Time Offers",
  "offers.hero.desc": "Take advantage of our exclusive offers on precision medicine and comprehensive assessment packages",
  "offers.valid_until": "Valid Until",
  "offers.book": "Book at Discounted Price",
  "offers.save": "Save",
  "offers.limited": "Limited Offer",
  "doctors.profile.not_found": "Doctor not found",
  "doctors.profile.back": "Back to Doctors",
  "doctors.profile.reviews": "reviews",
  "doctors.profile.book_appointment": "Book Appointment",
  "doctors.profile.languages": "Languages",
  "doctors.profile.working_days": "Working Days",
  "doctors.profile.days_per_week": "{{count}} days/week",
  "doctors.profile.working_days_title": "Working Days:",
  "doctors.profile.qualifications": "Qualifications",
  "doctors.profile.achievements": "Achievements & Certifications",
  "doctors.profile.specializations": "Specialties",
  "doctors.profile.other_doctors": "Other Doctors You May Like",
  "doctors.profile.booking_cta_title": "Want to book an appointment with {{name}}?",
  "doctors.profile.booking_cta_desc": "Book your appointment now and we will contact you to confirm the time",
  "doctors.profile.book_now_btn": "Book Appointment Now",
  "doctors.tab.about": "About the Doctor",
  "doctors.tab.specializations": "Specializations & Achievements",
  "doctors.tab.reviews": "Patient Reviews",
  "doctors.tab.calendar": "Available Schedule",
  "services.detail.not_found": "Service not found",
  "services.detail.back": "Back to Services",
  "services.detail.platform_badge": "Precision Medicine Platform",
  "services.detail.depth.clinical": "Clinical Depth",
  "services.detail.depth.technical": "Technical Depth",
  "services.detail.depth.international": "International Depth",
  "services.detail.book.title": "Book Your Appointment Now",
  "services.detail.book.start_price": "Prices start from",
  "services.detail.book.btn": "Book Appointment",
  "services.detail.book.whatsapp": "Inquire via WhatsApp",
  "services.detail.book.quality": "Quality Service Guarantee",
  "services.detail.book.hours": "90–120 Min Sessions",
  "services.detail.book.report": "Detailed Electronic Report",
  "services.detail.about": "About this Service",
  "services.detail.procedures": "Procedures & Exams Available",
  "services.detail.prices": "Prices & Rates",
  "services.detail.prices.vat_note": "All prices include VAT. Prices may vary depending on the case. Contact us for inquiries.",
  "services.detail.doctors": "Specialized Consultants",
  "services.detail.faqs": "Frequently Asked Questions",
  "services.detail.cta.heading": "Ready for a Real Deep Assessment?",
  "services.detail.cta.desc": "Our team of precision medicine experts in {{name}} is ready to give your case the time and depth it deserves",
  "services.detail.quick_book": "Quick Book",
  "services.detail.whatsapp_label": "WhatsApp",
  "services.detail.related": "Related Services",
  "services.detail.why_us": "Why The Medical Avenue?",
  "services.detail.dimensions.title": "Three Integrated Dimensions of Care",
  "services.detail.dimensions.desc": "What distinguishes The Medical Avenue from any traditional clinic",
  "services.detail.methodology.badge": "The Medical Avenue Methodology",
  "services.detail.methodology.title": "How We Work — Deep Assessment Methodology",
  "services.detail.methodology.desc": "We are not a clinic that only deals with the complaint — we dissect the case and read beyond the symptom, connecting the current health status with future risks",
  "services.detail.methodology.step_prefix": "Step",
  "services.detail.methodology.full_btn": "Show Full Methodology",
  "services.detail.methodology.step1.title": "Deep Listening",
  "services.detail.methodology.step1.desc": "We start with an extended listening session that goes beyond the main complaint — understanding the full health history, lifestyle, genetic factors, and psychological & social context.",
  "services.detail.methodology.step1.duration": "30–45 min",
  "services.detail.methodology.step1.tag": "Clinical Depth",
  "services.detail.methodology.step2.title": "Multi-Layered Assessment",
  "services.detail.methodology.step2.desc": "We dissect the case across multiple layers: clinical, laboratory, functional, and genetic. We do not settle for what is visible — we read beyond the symptom.",
  "services.detail.methodology.step2.duration": "60–90 min",
  "services.detail.methodology.step2.tag": "Technical Depth",
  "services.detail.methodology.step3.title": "Future Risk Prediction",
  "services.detail.methodology.step3.desc": "We connect current health with future risks. We use DNA Risk Score, metabolic indicators, and biological age to build a comprehensive proactive picture.",
  "services.detail.methodology.step3.duration": "Integrated Analysis",
  "services.detail.methodology.step3.tag": "Precision Medicine",
  "services.detail.methodology.step4.title": "International Consultation When Needed",
  "services.detail.methodology.step4.desc": "For complex cases, we consult our international network in the USA, South Korea, and elsewhere. A structured, not cosmetic, Second Opinion.",
  "services.detail.methodology.step4.duration": "7–14 days",
  "services.detail.methodology.step4.tag": "International Depth",
  "services.detail.methodology.step5.title": "Personalized Plan",
  "services.detail.methodology.step5.desc": "We design a treatment plan based on the patient's unique biology and health trajectory — no generic protocols, but a personalized medical decision.",
  "services.detail.methodology.step5.duration": "Interpretation Session",
  "services.detail.methodology.step5.tag": "Personalization",
  "services.detail.methodology.step6.title": "Close Follow-up",
  "services.detail.methodology.step6.desc": "Our care does not end at diagnosis. We monitor indicators, adjust the plan, and stay in constant contact with the patient via the application and periodic visits.",
  "services.detail.methodology.step6.duration": "Continuous",
  "services.detail.methodology.step6.tag": "Continuity",
  "services.detail.quote": "We understand before we decide — we analyze before we intervene — we anticipate before we chase",
  "services.detail.philosophy_title": "The Medical Avenue Philosophy in Precision Medicine",
  "packages.philosophy.title": "Our Care Philosophy",
  "packages.philosophy.desc": "Four principles that guide every package we offer",
  "packages.detail.feature": "Feature",
  "packages.detail.current": "Current Package",
  "packages.detail.total_price": "Total Price",
  "packages.detail.book_now": "Book Package Now",
  "packages.detail.not_found": "Package not found",
  "packages.detail.back": "Back to Packages",
  "packages.detail.original_price": "Original Price",
  "packages.detail.preparation": "Preparation Guidelines",
  "packages.detail.includes": "Package Inclusions",
  "packages.detail.comparison": "Package Comparison",
  "packages.detail.trust.title": "Fully Trusted Medical Service",
  "packages.detail.trust.desc": "All our packages are delivered under the supervision of elite specialized consultants with guaranteed quality and confidentiality standards",
  "packages.detail.preparation.default_desc": "Please follow these simple guidelines to ensure the most accurate results for your laboratory tests and assessment session",
  "packages.tab.overview": "Overview",
  "packages.tab.includes": "Inclusions",
  "packages.tab.preparation": "Preparation",
  "packages.tab.compare": "Comparison",
  "packages.tab.faq": "FAQs",
  "packages.detail.target_title": "Who is this package for?",
  "packages.detail.components_title": "Package Components",
  "packages.detail.components_count": "{{count}} items",
  "packages.detail.compare_title": "Compare with {{category}} packages",
  "packages.detail.compare_desc": "{{count}} other packages in this level — choose the best fit",
  "packages.detail.view_compare": "View Comparison",
  "packages.detail.main_services": "Main Services",
  "packages.detail.full_list": "Full Inclusion List",
  "packages.detail.how_prep": "How to Prepare for the Exam?",
  "packages.detail.important_alert": "Important Notice",
  "packages.detail.important_alert_desc": "If you have any special medical conditions or take medications, please inform the medical team before the session.",
  "packages.detail.compare_level": "Compare {{category}} Packages",
  "packages.detail.compare_level_desc": "Compare all available packages in the \"{{category}}\" level and choose the most suitable one for your needs",
  "packages.detail.other_packages": "Other Packages in This Level",
  "packages.detail.questions_count": "{{count}} questions",
  "packages.detail.have_other_q": "Have Another Question?",
  "packages.detail.have_other_q_desc": "Our team is ready to answer all your inquiries",
  "packages.detail.ready_book": "Ready to Book?",
  "packages.detail.ready_book_desc": "Book now and start your journey to better health",
  "packages.detail.price_label": "Package Price",
  "packages.detail.duration_label": "Duration",
  "packages.detail.choose_best": "Choose the best package for your needs",
  "packages.detail.have_inquiry": "Have an Inquiry?",
  "offers.countdown.days": "d",
  "offers.countdown.hours": "h",
  "offers.countdown.minutes": "m",
  "offers.countdown.seconds": "s",
  "offers.discount_badge": "Discount {{percent}}%",
  "offers.save_label": "Save {{amount}} SAR",
  "offers.book_discounted": "Book at Discounted Price",
  "offers.exclusive_discount": "Exclusive Discount",
  "offers.packages_count": "on {{count}} selected packages",
  "offers.ends_in": "Offer ends in",
  "offers.all_offers": "All Offers",
  "offers.stats.savings": "Total Savings",
  "offers.stats.savings.desc": "On all included packages",
  "offers.stats.ends_soon": "Nearest Offer Ends",
  "offers.stats.ends_soon.desc": "Book before it expires",
  "offers.stats.packages": "Included Packages",
  "offers.stats.packages.desc": "With special discounts",
  "offers.stats.guarantee": "Medical Quality",
  "offers.stats.guarantee.desc": "Under consultant supervision",
  "offers.coupon.title": "Exclusive Coupon Code",
  "offers.coupon.desc": "Copy the code and use it on the booking page for an extra discount",
  "offers.coupon.copy": "Copy Code",
  "offers.coupon.copied": "Code Copied",
  "offers.notify.title": "Subscribe for Exclusive Offers",
  "offers.notify.desc": "Don't miss precision medicine deals and seasonal packages tailored to your biology",
  "offers.notify.email_placeholder": "Your Email...",
  "offers.notify.subscribe": "Subscribe Now",
  "offers.notify.success": "Subscribed successfully!",
  "offers.stats.active": "Active Seasonal Offers",
  "offers.stats.packages_active": "Packages on Offer",
  "offers.stats.highest": "Highest Discount",
  "offers.stats.total_savings": "SAR Total Savings",
  "offers.flash_sale": "Flash Sale",
  "offers.limited_time": "Limited Time Offers",
  "offers.limited_time_desc": "Ends soon — Don't miss out!",
  "offers.seasonal_badge": "Seasonal Offers",
  "offers.seasonal_title": "Current Seasonal Offers",
  "offers.how_redeem": "How to Redeem Offers?",
  "offers.how_redeem_desc": "Simple steps to claim your discount",
  "faq.qa_label": "Q&A",
  "faq.response_time": "Response Time",
  "faq.support_24_7": "Continuous Support",
  "faq.categories_title": "Categories",
  "faq.all_questions": "All Questions",
  "faq.call_directly": "Call Us Directly",
  "faq.search_results": "Search results for:",
  "faq.search_results_count": "({{count}} results)",
  "faq.no_results_desc": "Try different search terms or contact us directly",
  "faq.still_have_desc": "Our precision medicine experts are available to answer all your inquiries — whether about deep assessment, DNA analysis, or international second opinion",
  "faq.send_message": "Send a Message",
  "faq.cta.precision_platform": "Precision Medicine Platform",
  "faq.cta.card1_title": "Multi-layer Deep Assessment",
  "faq.cta.card1_desc": "90–120 minute sessions to fully understand the case before any decision",
  "faq.cta.card2_title": "DNA Analysis & Future Risks",
  "faq.cta.card2_desc": "We read your genetic predispositions to preempt risks before they become a reality",
  "faq.cta.card3_title": "International Extension When Needed",
  "faq.cta.card3_desc": "Expert network in the USA and South Korea for cases requiring a broader perspective",
  "dna.ai.urgency.low": "Low Urgency",
  "dna.ai.urgency.medium": "Medium Urgency",
  "dna.ai.urgency.high": "High Urgency",
  "dna.ai.urgency.critical": "Critical Urgency",
  "dna.ai.report_title": "Smart AI Report",
  "dna.ai.report_desc": "Get a detailed personalized medical report written by AI",
  "dna.ai.includes": "What the report includes:",
  "dna.ai.includes.item1": "Executive summary of your health status",
  "dna.ai.includes.item2": "Key risk analysis with explanation",
  "dna.ai.includes.item3": "Customized practical medical recommendations",
  "dna.ai.includes.item4": "Immediate steps for follow-up",
  "dna.ai.includes.item5": "Urgency level assessment",
  "dna.ai.generate_btn": "Generate Smart Report",
  "dna.ai.generating": "Writing smart report...",
  "dna.ai.loading_desc": "Analyzing your data...",
  "dna.ai.loading_sub": "AI is writing your personalized medical report",
  "dna.ai.medical_report": "Smart Medical Report",
  "dna.ai.medical_report_desc": "Written by AI based on your answers",
  "dna.ai.rec_title": "Medical Recommendations",
  "dna.ai.next_steps": "Next Steps",
  "dna.ai.disclaimer": "This report is generated by AI and does not replace medical advice",
  "dna.ai.regenerate": "Regenerate",
  "dna.risk.low": "Low",
  "dna.risk.low_desc": "Your health risks are low — early prevention maintains this level",
  "dna.risk.medium": "Moderate",
  "dna.risk.medium_desc": "There are risk factors that warrant careful evaluation and regular follow-up",
  "dna.risk.high": "High",
  "dna.risk.high_desc": "The level of risk warrants a deep assessment and personalized preventive plan",
  "dna.risk.critical": "Very High",
  "dna.risk.critical_desc": "Early intervention is essential — deep assessment enables you to preempt risks",
  "dna.result.suitability": "Best for you",
  "dna.result.recommend_title": "Recommended Package for Your Case",
  "dna.result.recommend_desc": "Based on your answers, these packages are best suited to your level of risk",
  "dna.result.disclaimer_desc": "This assessment is estimated and based on your answers — it does not replace an actual clinical evaluation with a specialized consultant. Real DNA Risk Score requires precise laboratory genetic analysis.",
  "dna.result.cardiac": "Cardiovascular",
  "dna.result.metabolic": "Metabolism & Diabetes",
  "dna.result.neuro": "Nervous System",
  "dna.result.bone": "Bones & Joints",
  "dna.result.mental": "Mental Health",
  "dna.result.risk_platform": "Genetic Assessment & Risks",
  "dna.result.early_change": "Early assessment changes the course",
  "dna.result.genes_destiny": "Genes are not destiny",
  "dna.result.detailed_analysis": "Detailed Risk Analysis",
  "dna.result.book_consultant": "Book a Real Assessment with a Consultant",
  "dna.q.question_label": "Question",
  "dna.q.of_label": "of",
  "dna.q.multiselect_label": "Select all that apply",
  "dna.q.singleselect_label": "Select one option",
  "dna.intro.badge": "Free Interactive Tool",
  "dna.intro.title": "Discover Your Future Health Risk Level",
  "dna.intro.desc": "10 interactive questions analyzing your genetic and environmental risk factors — recommending the best package for your health journey",
  "dna.intro.start": "Start Assessment Now — Free",
  "dna.intro.learn_more": "Learn about the Real DNA Risk Score",
  "dna.intro.how_works": "How does the assessment work?",
  "dna.intro.how_works_desc": "We analyze your main risk factors and build an estimated picture of your future health risk level",
  "dna.intro.step1_title": "Answer 10 Questions",
  "dna.intro.step1_desc": "Questions covering family history, lifestyle, current symptoms, and environmental factors",
  "dna.intro.step2_title": "We Analyze Your Risks",
  "dna.intro.step2_desc": "An analytical algorithm evaluates 5 main health areas and calculates the overall risk level",
  "dna.intro.step3_title": "Personal Recommendation",
  "dna.intro.step3_desc": "We recommend the best package for your risk level with a direct link to book",
  "dna.intro.eval_title": "Health Areas We Assess",
  "dna.intro.start_btn": "Start DNA Risk Score Assessment",
  "dna.intro.free_note": "Completely free · No registration required · Instant results",
  "dna.quiz.progress_completed": "completed",
  "dna.quiz.prev": "Previous",
  "dna.quiz.next": "Next",
  "dna.quiz.show_results": "Show Results",
  "dna.result.hero_title": "DNA Risk Score Assessment Results",
  "dna.result.hero_desc": "Based on your answers, this is our estimated assessment of your health risk level",
  "dna.bottom.title": "Do you want a real genetic assessment?",
  "dna.bottom.desc": "Real DNA Risk Score requires precise laboratory genetic analysis — book a session with our consultants to start your journey",
  "dna.bottom.book": "Book a DNA Risk Score Session",
  "dna.bottom.learn": "Learn about the Service",
};

export default en_pages;
